<template>
  <div class="card is-min-width-700" v-if ="ligneCommande && affectations">
    <header class="bandeau-modal card-header">
    </header>
    <div class="pdl-20px pdr-20px">
      <div class="center">
        <div class="columns is-gapless">
          <div class="column mgt-20px">
            <h1 class="title is-size-3">
              {{ $t('gestionAffectation.titlePopUpMultiAffectationCommande',
                { face: face.reference }) }}
            </h1>
          </div>
        </div>
      </div>
      <div class="card-content pdl-0 pdr-0">
        <div class="has-text-default mgb-20px columns is-marginless is-multiline">
           <span class="has-text-default column is-12 is-paddingless">
            {{ ligneCommande.libelle }}
           </span>
          <span class="has-text-default column is-12 is-paddingless">
            {{ getPeriodeVendue(ligneCommande) }}
          </span>
        </div>
        <div class="mgb-20px">
          <date-picker :dates='dates' @recherche="chargerDonnees"
            :updateEndDateAtChangeStartDate="false"/>
        </div>
        <div class="mgb-20px">
          <v-client-table
            :data="affectations"
            :columns="columns"
            :options="options">
            <div slot="commande" slot-scope="props">
              <router-link-blank :to="{ name: 'c.bodac.commandes',
                          params: { id: getIdCommande(props.row) }}"
                                :message="getCodeCommande(props.row)">
              </router-link-blank>
            </div>
            <div slot="anneeSemaine" slot-scope="props">
              {{ getSemaine(props.row.anneeSemaine) }}
            </div>
            <div slot="ordreTravailId" slot-scope="props" class="has-text-centered">
              <router-link-blank :to="{ name: 'c.logistique.ordre_travail-affichage',
                                      params: { id: props.row.ordreTravailId } }" icon="open-in-new"
                                   typeIcon="is-primary" custom-size="mdi-18px"
                                   v-if ="props.row.ordreTravailId">
              </router-link-blank>
            </div>
            <div slot="actionLogistique" slot-scope="props">
              {{$t('gestionAffectation.tab.actionLogistiqueValues.'+ props.row.actionLogistique)}}
            </div>
            <div slot="delete" slot-scope="props" >
              <a @click=" popupSupp(props.row)">
                <b-icon
                  icon="delete-forever"
                  type="is-danger"
                  :class="{ 'text-access-no-permission'
                  : !checkPermissions(permAffectation.supprimer) || !!props.row.ordreTravailId}">
                </b-icon>
              </a>
            </div>
          </v-client-table>
        </div>
        <footer>
          <b-field>
            <div class="boutonAction center">
              <a class="button" @click="$parent.close()">
                {{ $t('general.button.close')}}
              </a>
            </div>
          </b-field>
        </footer>
      </div>
    </div>
    <b-modal v-model="popUpDesaffecter" has-modal-card class="modal">
      <pop-up-prevention
        :messHeader="this.$t('gestionAffectation.popUpDesaffecter.title')"
        :cancel="this.$t('general.non')"
        :validate="this.$t('general.oui')"
        @no="popUpDesaffecter = false"
        @yes="desaffecter"/>
    </b-modal>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import datePicker from '@/components/general/datePicker';
import { affecter } from '@/api/logistique/tourneeFaceSemaine';
import { AFFECTATION } from '@/configuration/logistique/permissionsLogistiqueConf';
import formatDate from '@/services/general/formatDate';
import getAnneeSemaineFromDate from '@/services/general/getAnneeSemaineFromDate';
import messageErreur from '@/services/general/messageErreur';
import messageSucces from '@/services/general/messageSucces';
import popUpPrevention from '@/components/general/popUpPrevention';
import {
  NO_PER_PAGE_VALUE, RESULTS_PER_POP_UP, SORT_ICON, TEXTS,
} from '@/configuration/clientTableConf';

const Permissions = createNamespacedHelpers('permissions');
const TourneeFaceSemaine = createNamespacedHelpers('tourneeFaceSemaine');
const Societe = createNamespacedHelpers('societe');

export default {
  name: 'p_affectationsAutreCommande',
  props: {
    ligneCommande: {
      type: Object,
      required: true,
    },
    toutesLignesCommandesIds: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      dates: {
        dateDebut: this.ligneCommande.dateDebut,
        dateFin: null,
      },
      affectations: null,
      affectationASupp: null,
      popUpDesaffecter: false,
      permAffectation: AFFECTATION,
    };
  },
  components: {
    popUpPrevention,
    routerLinkBlank,
    datePicker,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...TourneeFaceSemaine.mapGetters({
      tourneeFaceSemaine: 'items',
      totalCount: 'total',
      critereRecherche: 'critereRecherche',
    }),
    face() {
      return this.ligneCommande.produit;
    },
    columns() {
      const cols = [
        'commande',
        'anneeSemaine',
        'actionLogistique',
        'affectationLogistiqueLigneCommandeLibelle',
        'ordreTravailId',
        'delete',
      ];
      return cols;
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          commande: this.$i18n.t('gestionAffectation.tab.commandeTitle'),
          actionLogistique: this.$i18n.t('gestionAffectation.tab.actionLogistique'),
          anneeSemaine: this.$i18n.t('gestionAffectation.tab.anneeSemaineTitle'),
          affectationLogistiqueLigneCommandeLibelle: this.$i18n.t('gestionAffectation.tab.visuel'),
          delete: '',
          ordreTravailId: this.$i18n.t('gestionAffectation.tab.ordreTravailId'),
        },
        sortable: [
          'commande',
          'anneeSemaine',
          'actionLogistique',
          'affectationLogistiqueLigneCommandeLibelle',
          'ordreTravailId',
        ],
        texts: texts,
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_POP_UP,
        columnsClasses: {
          delete: 'colonneSelected-35 ',
          ordreTravailId: 'colonneAction-75',
        },
      };
    },
  },
  methods: {
    ...TourneeFaceSemaine.mapActions({
      actionLoadTourneeFaceSemaine: 'loadTourneeFaceSemaine',
    }),
    getIdCommande(tfs) {
      return tfs.commandes
        .filter(tfsC => tfsC.ligneCommandeId === tfs.affectationLogistiqueLigneCommandeId)[0]
        .commandeId;
    },
    getCodeCommande(tfs) {
      return tfs.commandes
        .filter(tfsC => tfsC.ligneCommandeId === tfs.affectationLogistiqueLigneCommandeId)[0]
        .code;
    },
    getSemaine(anneeSemaine) {
      return this.$i18n.t('gestionAffectation.tab.anneeSemaine', {
        semaine: anneeSemaine.toString().substring(4, 6),
        annee: anneeSemaine.toString().substring(0, 4),
      });
    },
    getPeriodeVendue(ligne) {
      if (ligne.dateDebut && ligne.dateFin) {
        return this.$t('detail.article.date', { dateDebut: formatDate(ligne.dateDebut), dateFin: formatDate(ligne.dateFin) });
      }
      return this.$t('dateDevis.pasDate');
    },
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    refreshList(demande) {
      const demandeEcran = this.ligneCommande.demandesLogistique.find(d => {
        return d.id === demande.id;
      });
      demandeEcran.datePlanification = demande.datePlanification;
      demandeEcran.actionLogistique = demande.actionLogistique;
      this.tri();
    },
    popupSupp(affectation) {
      if (!this.checkPermissions(this.permAffectation.supprimer) || !!affectation.ordreTravailId) {
        return;
      }
      this.affectationASupp = affectation;
      this.popUpDesaffecter = true;
    },
    async desaffecter() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await affecter({
          tourneeFaceSemaineIds: [this.affectationASupp.id],
          ligneCommandeId: null,
          demandeLogistiqueId: null,
        });
        const indexAffectationASupp = this.affectations.findIndex(a => {
          return this.affectationASupp.id === a.id;
        });
        if (indexAffectationASupp > -1) {
          this.affectations.splice(indexAffectationASupp, 1);
        }
        this.affectationASupp = null;
        this.popUpDesaffecter = false;
        loadingComponent.close();
        messageSucces(this.$i18n.t('demandeLogistique.popUpDesaffecter.success'));
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    tri() {
      this.affectations = this.affectations.sort((a, b) => {
        return a.anneeSemaine - b.anneeSemaine;
      });
    },
    async chargerDonnees() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const data = {
          query: {
            affectationLogistiqueLigneCommandeIdsAExclure: this.toutesLignesCommandesIds,
            estAffectee: true,
            societeId: this.societeActiveId,
            produitIds: [this.ligneCommande.produitId],
            anneeSemaineBetweeen: {
              anneeSemaineDebut: getAnneeSemaineFromDate(this.dates.dateDebut),
              anneeSemaineFin: getAnneeSemaineFromDate(this.dates.dateFin),
            },
          },
        };
        await this.actionLoadTourneeFaceSemaine(data);
        this.affectations = cloneDeep(this.tourneeFaceSemaine);
        this.tri();
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
  },
  async mounted() {
    await this.chargerDonnees();
  },
};
</script>
